import React, { useState, useEffect } from "react";

const ModalEditarBoleto = ({ isOpen, onClose, initialData, onSave }) => {
    const [valor, setValor] = useState("");
    const [vencimento, setVencimento] = useState("");
    const [loading, setLoading] = useState(false);
    const [abatimento, setAbatimento] = useState(0);

    useEffect(() => {
        if (initialData) {
            setValor(initialData.valor || "");
            setAbatimento(initialData.valor_abatimento || 0);
            setVencimento(
                initialData.vencimento
                    ? new Date(initialData.vencimento).toISOString().split("T")[0]
                    : ""
            );
        }
    }, [initialData]);

    if (!isOpen) return null;

    const handleSave = async () => {
        try {
            setLoading(true);
            await onSave({ ...initialData, valor, vencimento, abatimento });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h2 style={styles.title}>Editar Boleto</h2>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Valor</label>
                    <input
                        type="number"
                        value={valor}
                        disabled
                        onChange={(e) => setValor(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Vencimento atual</label>
                    <input
                        type="date"
                        value={vencimento}
                        disabled
                        style={styles.input}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Novo vencimento</label>
                    <input
                        type="date"
                        value={vencimento}
                        min={new Date().toISOString().split("T")[0]} // 👈 bloqueia datas anteriores a hoje
                        onChange={(e) => setVencimento(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Valor Abatimento</label>
                    <input
                        type="number"
                        value={abatimento}
                        onChange={(e) => setAbatimento(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <div style={styles.actions}>
                    <button
                        onClick={handleSave}
                        style={{ ...styles.btnPrimary, opacity: loading ? 0.7 : 1 }}
                        disabled={loading}
                    >
                        {loading ? "Salvando..." : "Alterar"}
                    </button>
                    <button
                        onClick={onClose}
                        style={styles.btnSecondary}
                        disabled={loading}
                    >
                        Sair
                    </button>
                </div>
            </div>
        </div>
    );
};

/** 🎨 Estilos simples inline */
const styles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000
    },
    modal: {
        background: "#fff",
        borderRadius: 12,
        padding: 24,
        width: "100%",
        maxWidth: 400,
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
    },
    title: { marginTop: 0, marginBottom: 20 },
    formGroup: { display: "flex", flexDirection: "column", marginBottom: 16 },
    label: { marginBottom: 6, fontWeight: 600, fontSize: 14 },
    input: {
        padding: "10px 12px",
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 14
    },
    actions: { display: "flex", justifyContent: "flex-end", gap: 10 },
    btnPrimary: {
        background: "#667eea",
        color: "#fff",
        padding: "10px 16px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 600
    },
    btnSecondary: {
        background: "#ddd",
        color: "#333",
        padding: "10px 16px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 600
    }
};

export default ModalEditarBoleto;
